import React, { useState } from 'react';
import styled from 'styled-components';
import eventTracker from '../../../../../helpers/eventTracker';
import events from '../../../events';

const Line = styled.div`
  height: 2px;
  width: 90%;
  border-radius: 20%;
  background-color: #efefef;
`;

const EeachAnswerContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const AnswerImage = styled.img`
  height: 8.33vh;
  margin-right: 3%;
  width: 20%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;

const AnswerContent = styled.div`
  margin-top: 3%;
  flex-direction: column;
  width: 85%;
`;

const AnswerSubject = styled.p`
  font-size: 15px;
  color: #6B6B6B;
`;

const AnswerMaterial = styled.p`
  font-size: 15px;
  width: 90vw;
`;

const AnswerDetail = styled.p`
  line-height: 15px;
  margin-bottom: 1%;
  font-size: 12px;
  width: 90%;
  white-space: normal;
  word-wrap: break-word;
  &.moreText {
    color: #6B6B6B;
  }

  &.lessText {
    background: linear-gradient(
      to bottom, #6B6B6B, #6B6B6B,
      #929292, #DEDEDE);
    -webkit-text-fill-color: transparent;
    -webkit-background-clip: text;
  }
`;

// const SeeMorelButton = styled.button`
//   background-color: transparent;
//   color: #00008B;
//   position: relative;
//   font-size: 12px;
//   margin-left: 18vw;
// `;

/**
 * This component shows a complete details of each answer for both correct and wrong answers
 * after the user finish each level
 *
 */

const EachAnswer = ({
  mat_image,
  disposal_header,
  mat_nm,
  disposal_body,
  mat_id_value,
  answerTitle
}) => {
  const showLessText = (str) => {
    if (str.length > 120) {
      const subString = str.substring(0, 120);
      const lastIndexOfSpace = subString.lastIndexOf(' ');
      if (lastIndexOfSpace === -1) {
        return subString;
      }
      return subString.substring(0, lastIndexOfSpace);
    }
    return str;
  };

  const removeHTMLTags = (str) => {
    const element = document.createElement('div');
    element.innerHTML = str;
    return element.textContent;
  };
  const [answerBody, setAnswerBody] = useState(removeHTMLTags(showLessText(disposal_body)));
  const [buttonText, setButtonText] = useState('See More');
  const showMore = () => {
    if (buttonText === 'See More') {
      setAnswerBody(removeHTMLTags(disposal_body));
      setButtonText('See Less');

      // track event
      eventTracker(events.DZ_RR_LEVEL_SUMMARY_SHOW_MORE_TAP, {
        mat_id: mat_id_value,
        correct: answerTitle === 'CORRECT ANSWERS'
      });
    } else {
      setAnswerBody(removeHTMLTags(showLessText(disposal_body)));
      setButtonText('See More');
    }
  };
  return (
    <EeachAnswerContainer>
      <AnswerImage
        src={mat_image}
        alt={`Image of ${mat_nm}`}
        style={{
          marginTop: '3%', maxWidth: '90%', maxHeight: '90%'
        }}
      />
      <AnswerContent>
        <AnswerSubject>
          {disposal_header}
        </AnswerSubject>
        <AnswerMaterial>
          {mat_nm}
        </AnswerMaterial>
        <AnswerDetail
          className={((buttonText === 'See Less' || removeHTMLTags(disposal_body).length <= 80) && 'moreText') || ((buttonText === 'See More') && 'lessText')}
          onClick={removeHTMLTags(disposal_body).length > 80 ? showMore : ''}
        >
          {answerBody}
        </AnswerDetail>
        <Line />
      </AnswerContent>
    </EeachAnswerContainer>
  );
};

export default EachAnswer;
